module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "interested"
  }, [_c('section', [_c('div', {
    staticClass: "grid-container"
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.preReg), function(row) {
    return _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-6"
    }, [_vm._v("\n          " + _vm._s(row.email) + "\n        ")]), _vm._v(" "), _c('div', {
      staticClass: "col-6"
    }, [_vm._v("\n          " + _vm._s(_vm.formatDate(row.when)) + "\n        ")])])
  })], 2)]), _vm._v(" "), _c('section', [_c('div', {
    staticClass: "grid-container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('h3', [_vm._v("BCC Combined Link:")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.bccLink
    }
  }, [_vm._v("\n            " + _vm._s(_vm.bccLink) + "\n          ")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('h3', [_vm._v("Email:")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [_c('h3', [_vm._v("When:")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-435fcd31"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Interested.vue
// module id = 706
// module chunks = 1